import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { DicesIcon, UtensilsIcon, BedDoubleIcon, FuelIcon, TruckIcon, ZapIcon, ArrowRightIcon } from 'lucide-react';
const features = [{
  id: 1,
  icon: DicesIcon,
  title: 'Las Vegas Casino',
  desc: 'Spannung pur – direkt an der Autobahn.',
  glow: 'rgba(168, 85, 247, 0.4)',
  colSpan: 'lg:col-span-2',
  image: 'https://images.unsplash.com/photo-1596838132731-3301c3fd4317?w=800&q=80',
  iconColor: 'text-neon-purple',
  link: '/casino'
}, {
  id: 2,
  icon: UtensilsIcon,
  title: 'Auszeit Restaurant',
  desc: 'Küche die überrascht – von früh bis spät.',
  glow: 'rgba(245, 158, 11, 0.4)',
  colSpan: 'lg:col-span-1',
  image: 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=800&q=80',
  iconColor: 'text-gold',
  link: '/restaurant'
}, {
  id: 3,
  icon: BedDoubleIcon,
  title: 'Hotel',
  desc: '60 Zimmer. 3 Sterne. Ab 49,95 €.',
  glow: 'rgba(14, 165, 233, 0.4)',
  colSpan: 'lg:col-span-1',
  image: 'https://images.unsplash.com/photo-1631049307264-da0ec9d70304?w=800&q=80',
  iconColor: 'text-electric-blue',
  link: '/hotel'
}, {
  id: 4,
  icon: FuelIcon,
  title: 'Shell Tankstelle',
  desc: '20 Zapfsäulen. Alle Kraftstoffe. Immer verfügbar.',
  glow: 'rgba(239, 68, 68, 0.4)',
  colSpan: 'lg:col-span-2',
  image: 'https://images.unsplash.com/photo-1545262810-77515befe149?w=800&q=80',
  iconColor: 'text-red-500',
  link: '/tankstelle'
}, {
  id: 5,
  icon: TruckIcon,
  title: 'LKW Parken & Truck2Park',
  desc: '100+ Stellplätze. DKV/UTA akzeptiert.',
  glow: 'rgba(20, 184, 166, 0.4)',
  colSpan: 'lg:col-span-2',
  image: 'https://images.unsplash.com/photo-1601584115197-04ecc0da31d7?w=800&q=80',
  iconColor: 'text-teal-accent',
  link: '/lkw-parken'
}, {
  id: 6,
  icon: ZapIcon,
  title: 'LNG & IONITY Laden',
  desc: 'LNG für Trucks. IONITY Schnellladen für E-Autos.',
  glow: 'rgba(34, 197, 94, 0.4)',
  colSpan: 'lg:col-span-1',
  image: 'https://images.unsplash.com/photo-1593941707882-a5bba14938c7?w=800&q=80',
  iconColor: 'text-neon-green',
  link: '/ladesaeulen'
}];
const containerVariants = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 40
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      type: 'spring',
      stiffness: 100,
      damping: 20
    }
  }
};
export function FeatureCards() {
  return <section className="py-24 px-4 w-full bg-base relative z-20" data-id="element-128">
      <div className="max-w-7xl mx-auto" data-id="element-129">
        <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-130">
          {features.map(feature => {
          const Icon = feature.icon;
          return <motion.div key={feature.id} variants={itemVariants} whileHover={{
            scale: 1.02,
            boxShadow: `0 0 40px ${feature.glow}`,
            borderColor: feature.glow.replace('0.4', '0.8')
          }} className={`glass-card rounded-3xl relative overflow-hidden group transition-colors duration-300 ${feature.colSpan}`} data-id="element-131">
                <Link to={feature.link} className="block" data-id="element-132">
                  {/* Background Image */}
                  <div className="absolute inset-0 z-0" data-id="element-133">
                    <img src={feature.image} alt={feature.title} className="w-full h-full object-cover opacity-50 group-hover:opacity-65 transition-opacity duration-500" data-id="element-134" />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" data-id="element-135" />
                  </div>

                  {/* Shimmer effect */}
                  <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/5 to-transparent group-hover:animate-[shimmer_1.5s_infinite] pointer-events-none z-10" data-id="element-136" />

                  <div className="relative z-10 p-8" data-id="element-137">
                    <div className={`w-14 h-14 rounded-2xl glass-card flex items-center justify-center mb-6 ${feature.iconColor}`} data-id="element-138">
                      <Icon className="w-7 h-7" strokeWidth={1.5} data-id="element-139" />
                    </div>
                    <h3 className="text-2xl font-heading font-bold mb-3 text-white" data-id="element-140">
                      {feature.title}
                    </h3>
                    <p className="text-white/60 font-body text-lg mb-4" data-id="element-141">
                      {feature.desc}
                    </p>
                    <span className={`inline-flex items-center gap-2 text-sm font-medium ${feature.iconColor} opacity-0 group-hover:opacity-100 transition-opacity duration-300`} data-id="element-142">
                      Mehr erfahren <ArrowRightIcon className="w-4 h-4" data-id="element-143" />
                    </span>
                  </div>
                </Link>
              </motion.div>;
        })}
        </motion.div>
      </div>
    </section>;
}